import { render, staticRenderFns } from "./InventoryImportPod.vue?vue&type=template&id=5ce37238&scoped=true"
import script from "./InventoryImportPod.vue?vue&type=script&lang=js"
export * from "./InventoryImportPod.vue?vue&type=script&lang=js"
import "./InventoryImportPod.vue?vue&type=style&index=0&id=5ce37238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce37238",
  null
  
)

export default component.exports